/* src/app/shared/components/account-mode-switcher/account-mode-switcher.component.scss */
:host {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: -30px;
}
.switcher-type {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
}
.switcher-type__item {
  font-weight: bold;
  position: relative;
}
.switcher-type__item--selected .pseudo {
  color: #000 !important;
  cursor: default !important;
}
.switcher-type__item--selected:after {
  content: "";
  display: block;
  width: 47px;
  left: 50%;
  transform: translateX(-50%);
  height: 3px;
  border-radius: 3px 3px 0 0;
  position: absolute;
  bottom: -5px;
  background: var(--mp-link-color);
}
/*# sourceMappingURL=account-mode-switcher.component.css.map */
